import { ControlType, FormFieldBase } from './form-field-base.model';

export class RadioButtonFormField extends FormFieldBase<string> {
  controlType: ControlType = 'radio-button';
}
